import React from "react";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { LocaleCurrency } from "helpers/Locale";
import { valueToString } from "helpers/Helpers";
import { IOrderTransaction } from "redux/reducers/models/order";

interface IOrderTenderRowsProps {
  transactions: IOrderTransaction[];
  currency?: string;
  onOpenTransaction: (transaction: IOrderTransaction) => void;
}

export default function OrderTenderRows(props: IOrderTenderRowsProps) {
  return (
    <>
      {props.transactions.map((transaction, index) => {
        return (
          <React.Fragment key={transaction.id ?? index}>
            <div className="flex justify-end">
              <div className="flex gap-3 items-center cursor-pointer" onClick={() => props.onOpenTransaction(transaction)}>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="leftMenuToolTip">
                      {moment.utc(transaction.processed_at).local().format("MMMM DD, YYYY") +
                        " at " +
                        moment.utc(transaction.processed_at).local().format("h:mm A")}
                    </Tooltip>
                  }
                >
                  <span className="order-totals-transaction-method text-lg text-semibold">
                    {valueToString(
                      transaction.payment_method === "card" ? transaction.payment_type : transaction.payment_method,
                    )}
                  </span>
                </OverlayTrigger>
                {transaction.payment_last_4 ? (
                  <span className="text-lg text-gray-500">•••• {transaction.payment_last_4}</span>
                ) : null}
              </div>
            </div>
            <span className="text-lg text-semibold">
              {transaction?.kind === "refund" ? <span>- </span> : null}
              <LocaleCurrency currency={props.currency} amount={transaction.amount} />
            </span>
            {transaction.note && <div className="text-sm text-subdued col-span-2 -mt-2">{transaction.note}</div>}
          </React.Fragment>
        );
      })}
    </>
  );
}
